__turbopack_context__.v({
  "Bar": "_63orBG_Bar",
  "Icon": "_63orBG_Icon",
  "Root": "_63orBG_Root",
  "Root--Bar": "_63orBG_Root--Bar",
  "Root--Floating": "_63orBG_Root--Floating",
  "skeleton-loading": "_63orBG_skeleton-loading",
});
